module.exports = __webpack_public_path__ + "static/media/assignment.4484bba8.png";